<template>
  <!-- If resource type is not "Image",
       or resource type is "Image" but no image exists,
       adjust the icon based on the adjustIcon method -->
  <router-link tag="div" :to="{name: 'resourceView', params: { id: resource.id }}" class="ingredient">
    <div class="thumb">
      <img v-if="resource.mediaType === 'Image' && !resource.url" src="static/img/ic-media-picture.png">
      <img v-else-if="resource.mediaType === 'Text' || resource.mediaType === 'Other'" src="static/img/ic-media-document.png">
      <img v-else-if="resource.mediaType === 'Website'" src="static/img/ic-media-link.png">
       <img v-else-if="resource.mediaType === 'Audio'" src="static/img/ic-media-audio.png">
        <img v-else-if="resource.mediaType === 'Linked Video'" src="static/img/ic-media-video.png">
      <img v-else src="static/img/ic-media-document.png">
      <div class="produced" v-if="resource.madeInProject">Produced by CultureLabs</div>
    </div>
    <div class="text"> 
      <router-link :title="resource.title" class="title" :to="{ name: 'resourceView', params: { id: resource.id }}">
          {{ resource.title | truncate(55, '...') }}
        </router-link>
      
      <p class="card-desc">{{ resource.description | truncate(100, '...') }}</p>
        <div class="metadata">
          <div class="creator">By <b>{{ resource.creator.login }}</b></div>
            <div class="addbookmark" v-if="authenticatedUser && this.$store.state.user.login !== this.resource.creator.login">
               <span class="mr-3"><b-link
                    :title="computedBookmark === false ? 'Add bookmark' : 'Remove Bookmark'"
                    v-b-tooltip.hover.top
                    v-on:click.stop="handleBookmarkResource(resource)"
                  >
                      <i
                        style="color: red"
                        :class="computedBookmark ? 'fas fa-bookmark fa-lg' : 'far fa-bookmark fa-lg'"
                      ></i>
                  </b-link></span>
            </div>
          
        </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'FeaturedIngredientsCard',
  props: {
    resource: Object
  },
  data() {
    return {
        bookmarked: undefined
      }
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    computedBookmark () {
        if (this.bookmarked !== undefined) {
          return this.bookmarked
        }
        else if (this.resource.bookmarked){
          return this.resource.bookmarked;
        }
        else{ return false;}
      }
  },
  methods: {
    handleBookmarkResource(resource) {
      var self=this;
      if (!this.computedBookmark) {
        this.$store
          .dispatch("bookmarkResource", resource.id)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              self.bookmarked = true;
            }
          });
      } else {
        this.$store
          .dispatch("deleteBookmarkResource", resource.id)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              self.bookmarked = false;
            }
          });
      }
    },
    adjustIcon (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'file-audio'
      } else if (mediaType === 'Linked Video') {
        return 'play-circle'
      } else if (mediaType === 'Website') {
        return 'link'
      } else if (mediaType === 'Text') {
        return 'file-alt'
      } else if (mediaType === 'Pdf') {
        return 'file-pdf'
      } else {
        return 'file-alt'
      }
    },
    adjustColor (mediaType) {
      // load the proper icon given the media type
      if (mediaType === 'Image') {
        return 'image'
      } else if (mediaType === 'Audio') {
        return 'color: #f0d6f1'
      } else if (mediaType === 'Linked Video') {
        return 'color: #ff6c6c'
      } else if (mediaType === 'Website') {
        return 'color: #95c9ff'
      } else if (mediaType === 'Text') {
        return 'color: #fff37a'
      } else if (mediaType === 'Pdf') {
        return 'color: red'
      } else {
        return 'color: #fff37a'
      }
    }
  }
}
</script>

<style scoped>
  .resource-card {
    height: 260px;
  }
  .card-img-top {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }
  .card-text {
      font-size: 20px !important;
  }
  .card-desc{
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/resources/FeaturedIngredientsCard.vue